import { graphql } from "babel-plugin-relay/macro";
import { useCallback, useContext } from "react";
import { useMutation } from "react-relay";
import {
  useTestShopifyTokenMutation$data,
  useTestShopifyTokenMutation as useTestShopifyTokenMutationType,
} from "./__generated__/useTestShopifyTokenMutation.graphql";
import SnackbarContext from "../contexts/SnackbarContext";

const mutation = graphql`
  mutation useTestShopifyTokenMutation($brandId: ID!) {
    testShopifyToken(brandId: $brandId) {
      shopName
      error
      status {
        state
        accessTokenLast4
        accessTokenExpiresAt
        refreshTokenExpiresAt
        refreshedAt
        error
        adminChangeUrl
      }
    }
  }
`;

const useTestShopifyTokenMutation = (): [
  (
    brandId: string,
    onCompleted?: (data: useTestShopifyTokenMutation$data) => void
  ) => void,
  boolean
] => {
  const [commitMutation, isMutationInFlight] =
    useMutation<useTestShopifyTokenMutationType>(mutation);
  const snackbarContext = useContext(SnackbarContext);

  const onMutate = useCallback(
    (
      brandId: string,
      onCompleted?: (data: useTestShopifyTokenMutation$data) => void
    ) => {
      commitMutation({
        variables: { brandId },
        onCompleted: (data, errors) => {
          const shopName = data.testShopifyToken?.shopName;
          const error = data.testShopifyToken?.error;
          if (errors || error || !shopName) {
            snackbarContext?.openSnackbar(
              error || "Shopify token test failed",
              "error"
            );
          } else {
            snackbarContext?.openSnackbar(
              `Shopify responded: ${shopName}`,
              "success"
            );
          }
          onCompleted && onCompleted(data);
        },
        onError: () => {
          snackbarContext?.openSnackbar("Shopify token test failed", "error");
        },
      });
    },
    [commitMutation, snackbarContext]
  );

  return [onMutate, isMutationInFlight];
};

export default useTestShopifyTokenMutation;
